import { Pipe, PipeTransform } from '@angular/core';

/**
 * Pipe que filtra elementos de un array segun un atributo
 * y un array de valores
 */
@Pipe({
    name: 'filter',
    standalone: false
})
export class FilterElementsPipe implements PipeTransform {
  constructor() { }

  /**
   * Filtra el array
   *
   * @param items items a filtrar
   * @param property atributo a tener en cuenta para el filtrado
   * @param value array de valores que se quieren filtrar
   */
  transform(items: any[], property: string, values: string[]): any[] {
    if (!items) {
      return [];
    };
    items = items.filter((section) => !section.isSeparator);
    return items.filter((item) => {
      const itemValue = item[property];

      return !values.includes(itemValue);
    });
  }
}
